import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { compose } from "redux";
import { Redirect } from "react-router-dom";
import TopBar from "../../components/TopBar";
import Sidebar from "../../components/Sidebar";
import { IoChevronUp, IoChevronDown, IoCloudUploadOutline, IoArrowBack, IoCheckmarkCircle, IoWarning, IoDocumentText, IoStatsChart, IoClipboardOutline, IoFolderOpenOutline, IoGridOutline, IoBarChartOutline, IoClose, IoSearch, IoSaveOutline } from "react-icons/io5";
import { HiOutlineDocumentText } from "react-icons/hi";
import { FiEdit2 } from "react-icons/fi";
import { BsRobot } from "react-icons/bs";
import { checkSurveyStatus, submitSurvey, uploadSurveyFile, deleteSurveyFile, getSurveyFiles, getAllAuditTemplates } from "../../store/actions/surveyActions";
import { getAllRisks_Report } from "../../store/actions/riskActions";
import { getSOAControls, updateSOAControl } from "../../store/actions/soaActions";
import LOADER from "../../assets/images/loader.svg";
import { RiTableFill, RiTableLine, RiGridFill, RiGridLine } from "react-icons/ri";




const STARTER_TEMPLATE_DESC_EN = "Starter template with no questions";

function Marketplace(props) {
    const {audit_templates, getAllAuditTemplatesFN, audits, token, checkSurveyStatusFN, submitSurveyFN, uploadSurveyFileFN, deleteSurveyFileFN, getSurveyFilesFN, getAllRisksFN, allRisks, getSOAControlsFN, updateSOAControlFN } = props;

    const { t } = useTranslation();

    const localizeTemplateDescription = (text) =>
        text === STARTER_TEMPLATE_DESC_EN ? t("auditMarketplace.starterTemplateNoQuestions") : text;

    const typeFilterLabel = (v) => {
        if (v === "All") return t("auditMarketplace.typeFilter.all");
        return t(`auditMarketplace.typeFilter.${String(v).toLowerCase()}`);
    };

    const statusFilterLabel = (v) => {
        if (v === "All") return t("auditMarketplace.statusFilter.all");
        if (v === "Open") return t("auditMarketplace.statusFilter.open");
        if (v === "In Progress") return t("auditMarketplace.statusFilter.inProgress");
        if (v === "Closed") return t("auditMarketplace.statusFilter.closed");
        return v;
    };

    // Ref for scroll container
    const scrollContainerRef = useRef(null);

    // Loading state
    const [loading, setLoading] = useState(false);
 
   

    const [viewMode, setViewMode] = useState("table"); // "table" | "grid"
    const showToggle = true;




    const [query, setQuery] = useState('');
    const [typeView, setTypeView] = useState('All');
    const [statusView, setStatusView] = useState('All');

    useEffect(() => {
        if (getAllAuditTemplatesFN) {
            getAllAuditTemplatesFN()
        }
    }, [getAllAuditTemplatesFN]);


    return token ? (
        <div className="w-full h-screen flex flex-col overflow-x-hidden bg-[#F8F8F8]">
            {/* Top bar */}
            <div className="flex-shrink-0">
                <TopBar />
            </div>

            {/* Main area: sidebar + scrollable content */}
            <div className="flex flex-1 overflow-hidden">
                {/* Sidebar */}
                <div className="flex-shrink-0 h-full">
                    <Sidebar className="h-full" />
                </div>

                {/* MAIN SCROLL AREA */}
                <div className="flex-1 overflow-y-auto" ref={scrollContainerRef}>
                    <div className="w-full max-w-[1450px] mx-auto px-4 pb-6 pt-6 bg-[#F8F8F8]">

                        {/* LOADING STATE */}
                        {loading ? (
                            <div className="flex items-center justify-center py-20">
                                <img src={LOADER} alt="Loading..." className="w-12 h-12" />
                            </div>
                        ) : (
                            <>
                                {/* Header */}
                                <div className="mb-6">
                                    <h1 className="text-2xl md:text-3xl font-bold text-[#0E0E0E] mb-3">
                                        {t("auditMarketplace.pageTitle")}
                                    </h1>
                                    <p className="text-gray-600 leading-relaxed">
                                        {t("auditMarketplace.pageSubtitle")}
                                    </p>
                                </div>

                           



                               <div className="bg-white border border-gray-200 rounded-xl p-4 mt-2 mb-4 shadow-sm">
                                    <div className="flex flex-wrap items-center gap-2">
                              
                                      {/* SEARCH */}
                                      <div className="relative flex-1 min-w-[260px]">
                                        <input
                                          value={query}
                                          onChange={(e) => setQuery(e.target.value)}
                                          placeholder={t("auditMarketplace.searchPlaceholder")}
                                          className="
                                          w-full bg-[#F3F4F6] rounded-md text-xs pl-8 pr-3 py-2
                                          outline-none border-none
                                          focus:outline-none focus:ring-0 focus:border-none
                                          active:outline-none active:ring-0 active:border-none
                                        "
                                        />
                                        <svg
                                          className="absolute left-2 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500"
                                          viewBox="0 0 24 24" fill="none"
                                        >
                                          <path
                                            d="M21 21l-4.35-4.35M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                      </div>
                              
                                      {/* TYPE FILTER */}
                                      <div className="relative">
                                        <svg className="absolute left-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24">
                                          <path
                                            d="M3 5h18l-7 8v4l-4 2v-6L3 5z"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                          />
                                        </svg>
                                        <select
                                          value={typeView}
                                          onChange={(e) => setTypeView(e.target.value)}
                                          className="
                                  appearance-none
                                  bg-[#F3F4F6] rounded-md text-xs pl-8 pr-6 py-2
                                  outline-none border-none
                                  focus:outline-none focus:ring-0 focus:border-none
                                "
                                        >
                                          {['All', 'Preventive', 'Detective', 'Mitigative'].map((typeVal) => (
                                            <option key={typeVal} value={typeVal}>{typeFilterLabel(typeVal)}</option>
                                          ))}
                                        </select>
                                        <svg className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-500" viewBox="0 0 20 20" fill="currentColor">
                                          <path d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" />
                                        </svg>
                                      </div>
                              
                                     
                              
                                      {/* STATUS FILTER */}
                                      <div className="relative">
                                        <svg className="absolute left-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24">
                                          <path d="M5 12h14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                                        </svg>
                                        <select
                                          value={statusView}
                                          onChange={(e) => setStatusView(e.target.value)}
                                          className="
                                  appearance-none
                                  bg-[#F3F4F6] rounded-md text-xs pl-8 pr-6 py-2
                                  outline-none border-none
                                  focus:outline-none focus:ring-0 focus:border-none
                                "
                                        >
                              
                                          {['All', 'Open', 'In Progress', 'Closed'].map((s) => (
                                            <option key={s} value={s}>{statusFilterLabel(s)}</option>
                                          ))}
                                        </select>
                                        <svg className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-500" viewBox="0 0 20 20" fill="currentColor">
                                          <path d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" />
                                        </svg>
                                      </div>
                              
                                      {/* GRID / TABLE TOGGLE ÔÇö LEFT EXACTLY AS BEFORE */}
                                      {showToggle && viewMode !== undefined && setViewMode && (
                                        <div className="flex items-center gap-0 ml-auto border border-gray-300 rounded-lg overflow-hidden">
                                          <button
                                            onClick={() => setViewMode("table")}
                                            className={`flex items-center justify-center gap-2 px-3.5 py-1.5 text-sm font-medium transition ${viewMode === "table"
                                                ? "bg-[#0E0E0E] text-white"
                                                : "bg-white text-gray-600 hover:bg-gray-50"
                                              }`}
                                          >
                                            {viewMode === "table" ? <RiTableFill size={16} /> : <RiTableLine size={16} />}
                                          </button>
                              
                                          <button
                                            onClick={() => setViewMode("grid")}
                                            className={`flex items-center justify-center gap-2 px-3.5 py-1.5 text-sm font-medium transition border-l border-gray-300 ${viewMode === "grid"
                                                ? "bg-[#0E0E0E] text-white"
                                                : "bg-white text-gray-600 hover:bg-gray-50"
                                              }`}
                                          >
                                            {viewMode === "grid" ? <RiGridFill size={16} /> : <RiGridLine size={16} />}
                                          </button>
                                        </div>
                                      )}
                              
                                    </div>
                                  </div>
                                      
                                  {viewMode === "grid" ? (
  <>
    {/* Templates grid */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
      {(audit_templates || []).map((tmpl) => {
        const title = tmpl.survey_template_name || tmpl.name || "Untitled Template";
        const rawDesc = tmpl.survey_template_description || tmpl.description || "";
        const desc = rawDesc
            ? localizeTemplateDescription(rawDesc)
            : "No description provided.";
        const questions = Number(tmpl.question_count ?? 0);
        const available = Number(tmpl.unlocked ?? 0) === 1;

        // Optional: map framework id -> label
        const frameworkLabel =
          tmpl.framework === 1 ? "ISO" :
          tmpl.framework === 2 ? "NIST" :
          tmpl.framework === 3 ? "SOC 2" :
          "Framework";

        return (
          <div
            key={`${tmpl.template_id ?? ""}-${tmpl.audit_template_id ?? ""}`}
            className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden"
          >
            {/* Top */}
            <div className="p-5">
              <div className="flex items-start justify-between gap-3">
                <div className="flex items-start gap-3">
                  {/* Icon block */}
                  <div className="w-11 h-11 rounded-xl bg-blue-600 flex items-center justify-center shadow-sm">
                    <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5">
                      <path
                        d="M7 4h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z"
                        stroke="white"
                        strokeWidth="1.8"
                      />
                      <path
                        d="M8.5 9h7"
                        stroke="white"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>

                  <div className="min-w-0">
                    <div className="flex items-center gap-2">
                      <p className="text-lg font-semibold text-gray-900 truncate">
                        {title}
                      </p>

                      {/* Availability pill */}
                      <span
                        className={[
                          "shrink-0 text-xs font-medium px-2.5 py-1 rounded-full border",
                          available
                            ? "bg-emerald-50 text-emerald-700 border-emerald-200"
                            : "bg-gray-50 text-gray-600 border-gray-200",
                        ].join(" ")}
                      >
                        {available ? t("auditMarketplace.badges.available") : t("auditMarketplace.badges.locked")}
                      </span>
                    </div>

                    <p className="mt-1 text-sm text-gray-600 line-clamp-2">
                      {desc}
                    </p>

                    {/* Tag pills */}
                    <div className="mt-3 flex flex-wrap gap-2">
                      <span className="text-xs px-2.5 py-1 rounded-full bg-gray-100 text-gray-700">
                        {frameworkLabel}
                      </span>
                      <span className="text-xs px-2.5 py-1 rounded-full bg-gray-100 text-gray-700">
                        Audit
                      </span>
                      <span className="text-xs px-2.5 py-1 rounded-full bg-gray-100 text-gray-700">
                        Compliance
                      </span>

                      {/* "+4" style extra pill (optional) */}
                      <span className="text-xs px-2.5 py-1 rounded-full bg-gray-100 text-gray-700">
                        +{Math.max(0, 4)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Stats box */}
              <div className="mt-4 rounded-xl border border-gray-200 bg-gray-50 p-4">
                <div className="grid grid-cols-2 gap-4">
                  <div className="flex items-center gap-2">
                    <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4 text-gray-500">
                      <path d="M7 7h10M7 12h10M7 17h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                    <div>
                      <p className="text-xs text-gray-500">{t("auditMarketplace.detailLabelQuestions")}</p>
                      <p className="text-sm font-semibold text-gray-900">{questions}</p>
                    </div>
                  </div>

                  <div className="flex items-center gap-2">
                    <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4 text-gray-500">
                      <path d="M12 8v5l3 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                      <path d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" stroke="currentColor" strokeWidth="2" />
                    </svg>
                    <div>
                      <p className="text-xs text-gray-500">Estimated Time</p>
                      <p className="text-sm font-semibold text-gray-900">~{Math.max(1, Math.round(questions / 20))} hrs</p>
                    </div>
                  </div>

                  <div className="flex items-center gap-2">
                    <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4 text-gray-500">
                      <path d="M7 4h10v16H7z" stroke="currentColor" strokeWidth="2" />
                      <path d="M9 8h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                    <div>
                      <p className="text-xs text-gray-500">{t("auditMarketplace.detailLabelModules")}</p>
                      <p className="text-sm font-semibold text-gray-900">{Math.max(1, Math.round(questions / 4))}</p>
                    </div>
                  </div>

                  <div className="flex items-center gap-2">
                    <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4 text-gray-500">
                      <path d="M12 3l7 4v6c0 5-3 8-7 8s-7-3-7-8V7l7-4Z" stroke="currentColor" strokeWidth="2" />
                      <path d="m9 12 2 2 4-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <div>
                      <p className="text-xs text-gray-500">{t("auditMarketplace.certificate")}</p>
                      <p className="text-sm font-semibold text-gray-900">{available ? "Yes" : "No"}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Key features */}
              <div className="mt-4">
                <p className="text-sm font-semibold text-gray-900">Key Features</p>
                <div className="mt-2 space-y-2">
                  {[
                    "Clause-based audit flow",
                    "Evidence & findings support",
                    "Progress tracking",
                  ].map((x) => (
                    <div key={x} className="flex items-start gap-2 text-sm text-gray-700">
                      <span className="mt-0.5 inline-flex w-5 h-5 rounded-full bg-emerald-50 border border-emerald-200 items-center justify-center">
                        <svg viewBox="0 0 24 24" fill="none" className="w-3.5 h-3.5 text-emerald-600">
                          <path d="m5 13 4 4L19 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </span>
                      <span>{x}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Bottom action bar */}
            <div className="px-5 pb-5">
              <div className="flex items-center justify-between gap-3">
                <div className="text-gray-900">
                  <p className="text-xs text-gray-500">Template</p>
                  <p className="text-lg font-semibold">
                    {frameworkLabel}
                    <span className="text-xs font-medium text-gray-500 ml-2">
                      #{tmpl.template_id ?? "-"}
                    </span>
                  </p>
                </div>

                <div className="flex items-center gap-2">
                  <button
                    disabled={!available}
                    onClick={() => {
                      // openTemplate(tmpl)
                    }}
                    className={[
                      "h-11 px-5 rounded-xl text-sm font-semibold transition",
                      available
                        ? "bg-gray-900 text-white hover:bg-gray-800"
                        : "bg-gray-200 text-gray-500 cursor-not-allowed",
                    ].join(" ")}
                  >
                    {available ? t("auditMarketplace.gridOpen") : t("auditMarketplace.badges.locked")}
                  </button>

                  <button
                    onClick={() => {
                      // openTemplateDetails(tmpl)
                    }}
                    className="h-11 w-11 rounded-xl border border-gray-200 bg-white hover:bg-gray-50 flex items-center justify-center"
                    title={t("auditMarketplace.details")}
                  >
                    <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5 text-gray-700">
                      <path d="M14 5h5v5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                      <path d="M10 14 19 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                      <path d="M19 14v5h-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                      <path d="M5 10V5h5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  </>
) : (
  <>
    {/* Templates List */}
    <div className="space-y-4">
      {(audit_templates || []).map((tmpl) => {
        const title = tmpl.survey_template_name || tmpl.name || "Untitled Template";
        const rawDesc = tmpl.survey_template_description || tmpl.description || "";
        const desc = rawDesc
            ? localizeTemplateDescription(rawDesc)
            : "No description provided.";
        const questions = Number(tmpl.question_count ?? 0);
        const available = Number(tmpl.unlocked ?? 0) === 1;

        // placeholders until you have real fields
        const modules = Math.max(1, Math.round(questions / 4));
        const hours = Math.max(1, Math.round(questions / 5));
        const price = "$4.0k"; // wire later
        const categoryPills = ["Banking", "Finance", "Insurance", "Insurance Brokers"];
        const extraCount = 3;

        return (
          <div
            key={`${tmpl.template_id ?? ""}-${tmpl.audit_template_id ?? ""}`}
            className="bg-white rounded-2xl border border-gray-200 shadow-sm p-5 flex items-center justify-between gap-6"
          >
            {/* Left */}
            <div className="flex items-start gap-4 min-w-0">
              {/* Icon */}
              <div className="w-12 h-12 rounded-2xl bg-blue-600 flex items-center justify-center shadow-sm shrink-0">
                <svg viewBox="0 0 24 24" fill="none" className="w-6 h-6">
                  <path
                    d="M7 4h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z"
                    stroke="white"
                    strokeWidth="1.8"
                  />
                  <path d="M8.5 9h7" stroke="white" strokeWidth="1.8" strokeLinecap="round" />
                </svg>
              </div>

              {/* Text */}
              <div className="min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <p className="text-lg font-semibold text-gray-900 truncate max-w-[520px]">
                    {title}
                  </p>

                  <span
                    className={[
                      "text-xs font-medium px-2.5 py-1 rounded-full border",
                      available
                        ? "bg-emerald-50 text-emerald-700 border-emerald-200"
                        : "bg-gray-50 text-gray-600 border-gray-200",
                    ].join(" ")}
                  >
                    {available ? t("auditMarketplace.badges.available") : t("auditMarketplace.badges.locked")}
                  </span>

                  <span className="text-xs font-medium px-2.5 py-1 rounded-full border border-gray-200 bg-gray-50 text-gray-700">
                    {t("auditMarketplace.badges.tutorialPackage")}
                  </span>
                </div>

                <p className="text-sm text-gray-600 mt-1 line-clamp-1">
                  {desc}
                </p>

                {/* Pills */}
                <div className="mt-3 flex flex-wrap gap-2">
                  {categoryPills.slice(0, 4).map((x) => (
                    <span
                      key={x}
                      className="text-xs px-2.5 py-1 rounded-full bg-gray-100 text-gray-700 border border-gray-200"
                    >
                      {x}
                    </span>
                  ))}
                  {extraCount > 0 && (
                    <span className="text-xs px-2.5 py-1 rounded-full bg-gray-100 text-gray-700 border border-gray-200">
                      +{extraCount}
                    </span>
                  )}
                </div>

                {/* Mini stats row */}
                <div className="mt-4 flex items-center gap-6 text-sm text-gray-600 flex-wrap">
                  <div className="flex items-center gap-2">
                    <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4 text-blue-600">
                      <path d="M7 7h10M7 12h10M7 17h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                    <span>{t("auditMarketplace.stats.modules", { count: modules })}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4 text-blue-600">
                      <path d="M4 6h16M4 12h16M4 18h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                    <span>{t("auditMarketplace.stats.questions", { count: questions })}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4 text-blue-600">
                      <path d="M12 8v5l3 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                      <path d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" stroke="currentColor" strokeWidth="2" />
                    </svg>
                    <span>{t("auditMarketplace.stats.hours", { count: hours })}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4 text-blue-600">
                      <path d="M12 3l7 4v6c0 5-3 8-7 8s-7-3-7-8V7l7-4Z" stroke="currentColor" strokeWidth="2" />
                    </svg>
                    <span>{t("auditMarketplace.certificate")}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Right */}
            <div className="flex items-center gap-4 shrink-0">
              <div className="text-right">
                <p className="text-2xl font-semibold text-gray-900">{price}</p>
                <p className="text-xs text-gray-500">{t("auditMarketplace.pricingOneTime")}</p>
              </div>

              <button
                className="h-10 px-4 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 text-sm font-semibold text-gray-800 flex items-center gap-2"
                onClick={() => {
                  // openTemplateDetails(tmpl)
                }}
              >
                <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4">
                  <path d="M14 5h5v5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  <path d="M10 14 19 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  <path d="M19 14v5h-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  <path d="M5 10V5h5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
                {t("auditMarketplace.details")}
              </button>

              <button
                disabled={!available}
                className={[
                  "h-10 px-4 rounded-lg text-sm font-semibold transition",
                  available
                    ? "bg-gray-900 text-white hover:bg-gray-800"
                    : "bg-gray-200 text-gray-500 cursor-not-allowed",
                ].join(" ")}
                onClick={() => {
                  // handlePurchaseOrOpen(tmpl)
                }}
              >
                {available ? t("auditMarketplace.purchase") : t("auditMarketplace.badges.locked")}
              </button>
            </div>
          </div>
        );
      })}
    </div>
  </>
)}

                            </>
                        )}

                    </div>
                </div>
            </div>
        </div>
    ) : (
        <Redirect to="/login" />
    );
}

const mapStateToProps = (state) => {
    //console.log("Marktpcle AUdits ", state.audits?.audit_templates)
    return {
        token: state.auth.token,
        allRisks: state.risk.all_risks_report || [],
        audit_templates: state.audits?.audit_templates
    };
};

const mapDispatchToProps = (dispatch) => ({
    checkSurveyStatusFN: () => dispatch(checkSurveyStatus()),
    submitSurveyFN: (data) => dispatch(submitSurvey(data)),
    uploadSurveyFileFN: (file, questionId) => dispatch(uploadSurveyFile(file, questionId)),
    deleteSurveyFileFN: (fileId) => dispatch(deleteSurveyFile(fileId)),
    getAllRisksFN: () => dispatch(getAllRisks_Report()),
    getSOAControlsFN: () => dispatch(getSOAControls()),
    updateSOAControlFN: (soa_id, data) => dispatch(updateSOAControl(soa_id, data)),
    getSurveyFilesFN: (surveyId, questionId) => dispatch(getSurveyFiles(surveyId, questionId)),
    getAllAuditTemplatesFN: () => dispatch(getAllAuditTemplates())
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Marketplace);